var map = {
	"./Home/404.vue": [
		"1622"
	],
	"./Home/Banner/banner.vue": [
		"6de3",
		"chunk-05adc480"
	],
	"./Home/Desk/desk.vue": [
		"e865",
		"chunk-b0789132"
	],
	"./Home/Home.vue": [
		"1c62"
	],
	"./Home/HotSale/hotSale.vue": [
		"0b13",
		"chunk-56cd15b6"
	],
	"./Home/Index/index.vue": [
		"7603",
		"chunk-51abd2c7"
	],
	"./Home/Order/gathering.vue": [
		"15f6",
		"chunk-629ac0aa"
	],
	"./Home/Order/order.vue": [
		"4a5d",
		"chunk-e99fd448"
	],
	"./Home/Order/orderFlowList.vue": [
		"aa30",
		"chunk-0ccbb075"
	],
	"./Home/Order/orderInfo.vue": [
		"ec48",
		"chunk-1c5e39a6"
	],
	"./Home/Pos/index.vue": [
		"afe1",
		"chunk-2d214447"
	],
	"./Home/Recommend/recommend.vue": [
		"2ed7",
		"chunk-4415145d"
	],
	"./Home/User/user.vue": [
		"6928",
		"chunk-050eaf5e"
	],
	"./Home/advertising/advertising.vue": [
		"e70f",
		"chunk-387fcff4"
	],
	"./Home/orderList/orderList.vue": [
		"0a3f",
		"chunk-ba6571f6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "da65";
module.exports = webpackAsyncContext;